module.exports = __webpack_public_path__ + "img/1.9ff3f3e0.png";